import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { MESSAGE_SENDER } from 'consts/enum';
import { generate6DigitUUID, hasClass } from 'helpers/helpers';
import { closeBtn } from 'icons/close';
import { quote } from 'icons/quote';
import { ENGT_CHAT } from 'js/bot.model';
import { removeQuote } from 'js/conversation';
import { textMessage } from './textMessage.model';
import { TextMessageTemplate } from './textMessage.template';

export class TextMessage {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = textMessage;
		this.setter(propData);
		this.data.id = propData.id || propData.message_id || `message-${generate6DigitUUID()}`;
	}

	scrollIntoView(id) {
		if (id.startsWith('engt', 0)) {
			id = id.slice(9);
		}
		const messageId = document.getElementById(id);
		if (messageId) {
			messageId.scrollIntoView(false);
			messageId.style.backgroundColor = '#cab4c621';
			messageId.style.borderRadius = '16px';
			setTimeout(() => {
				messageId.style.backgroundColor = 'transparent';
				messageId.style.borderRadius = '0px';
			}, 2000);
		}
	}

	initWrapper() {
		this.html = new MessageWrapper({
			...this.data,
			innerHTML: this.getQuoteMessageLocation()
				? /* html */
				  `
					<div class="engt-user-quote" id="engt-quote-${this.data.id}">
						${quote()}
					</div>
					${TextMessageTemplate({
						style: 'margin-left: unset;',
						...this.data,
					})}
				`
				: this.data.sender === MESSAGE_SENDER.BOT
				? TextMessageTemplate(this.data)
				: /* html */
				  `
					${TextMessageTemplate(this.data)}
				  	<div class="engt-quote" id="engt-quote-${this.data.id}"}>
						${quote()}
					</div>`,
		});
	}

	getQuoteMessageLocation() {
		return !(this.data.sender === MESSAGE_SENDER.BOT || this.data.sender === MESSAGE_SENDER.AGENT);
	}

	setQuoteText() {
		const QuotElement = document.getElementById('engtQuoteText');
		if (hasClass(QuotElement, 'engt-quote-text')) {
			removeQuote();
		}
		ENGT_CHAT.set('quotedMsgDetails', null);
		QuotElement.classList.remove('engt-hidden');
		QuotElement.classList.add('engt-quote-text');
		const QuoteMessage = document.createElement('div');
		ENGT_CHAT.set('quotedMsgDetails', {
			linked_event_id: this.data.id,
			linked_response_data: this.data.message.text,
		});

		/* html */
		const html = `
			<div class="engt-quote-linkedTextDescription" style="color:${ENGT_CHAT.get('config.botResponseTextColor')}" >
				<div class="engt-quote-linkedText">
			   		<div class="engt-quote-username">${this.data.sender === MESSAGE_SENDER.AGENT ? this.data.agent_name : 'You'}</div>
					<div class="engt-quote-user-text">${this.data.message.text}</div>
				</div>
				<div class="engt-close-quote" id="engt-close-quote-${this.data.id}">
				${closeBtn(ENGT_CHAT.get('config.botResponseTextColor'))}
				</div>
		 	</div>`;

		QuoteMessage.innerHTML = html;
		QuotElement.appendChild(QuoteMessage);
		QuotElement.querySelector('.engt-close-quote').addEventListener('click', () => {
			removeQuote();
		});
	}

	initEventHandlers() {
		const { id } = this.data;
		if (this.data.sender === MESSAGE_SENDER.USER || this.data.sender === MESSAGE_SENDER.AGENT) {
			this.html.querySelector(`#engt-quote-${id}`).addEventListener('click', () => {
				this.setQuoteText();
			});
		}
		ENGT_CHAT.set('scrollIntoView', this.scrollIntoView);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
